import { render, staticRenderFns } from "./ImportExportView.vue?vue&type=template&id=6aa72ec8&scoped=true"
import script from "./ImportExportView.vue?vue&type=script&lang=ts"
export * from "./ImportExportView.vue?vue&type=script&lang=ts"
import style0 from "./ImportExportView.vue?vue&type=style&index=0&id=6aa72ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa72ec8",
  null
  
)

export default component.exports